/// <reference types="node" />

import "./app";


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/entry.ts